
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection-acerca-de",
      function () {
        return require("private-next-pages/collection-acerca-de.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection-acerca-de"])
      });
    }
  